import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { X } from "lucide-react";
import { mmkBackToMmkButtonStyles } from "./styles";
import { MmkPageShell } from "./mmk-page-shell";

interface FocusSessionEmptyProps {
  onBack: () => void;
}

export const FocusSessionEmpty: React.FC<FocusSessionEmptyProps> = ({
  onBack,
}) => {
  return (
    <MmkPageShell>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 6,
          px: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, textAlign: "center", mb: 2, color: "#000000" }}
        >
          No more cards to review
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#000000", textAlign: "center", mb: 3, opacity: 0.8 }}
        >
          All cards in this focus have been passed. Great job!
        </Typography>
        <Button
          variant="outlined"
          onClick={onBack}
          sx={mmkBackToMmkButtonStyles}
          startIcon={<X size={18} />}
        >
          Back to MMM
        </Button>
      </Box>
    </MmkPageShell>
  );
};
